import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private apiURL = environment.backendApiUrl;
  private authService!: AuthService;
  public httpHeaders: HttpHeaders;

  constructor(private http: HttpClient, private injector: Injector) {
    this.httpHeaders = new HttpHeaders()
      .set('content-type', 'application/json')
      .set('Accept', 'application/json');
  }


  getAuthService(): AuthService {
    if (!this.authService) {
      this.authService = this.injector.get(AuthService);
    }
    return this.authService;
  }

  public getRequest(url: string): Observable<any> {
  const httpOptions = {
    headers: this.httpHeaders,
  };
  return this.http.get(url, httpOptions);
}

public postRequest(url: string, data: any): Observable<any> {
  const httpOptions = {
    headers: this.httpHeaders,
  };
  return this.http.post(url, data, httpOptions);
}


  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      console.error('An error occurred:', error.error);
    } else {
      console.error(`Status ${error.status}, body was: `, error.message);
    }
    return throwError(() => new Error('Connection Error'));
  }

  private isSsoTokenValid(): boolean {
    // Retrieve the SSO token and its expiry from local storage
    const ssoToken = localStorage.getItem('access_token');
    const expiresAt = localStorage.getItem('expires_at');
    const backendToken = localStorage.getItem('backend_api_token');
    
    // Check if the SSO token or its expiry is not available
    if (!ssoToken || !expiresAt || !backendToken) {
      return false;
    }

    // Check if the current date and time are before the expiry time
    const expiryDate = new Date(expiresAt);
    return new Date() < expiryDate;
  }

  private handleApiCall<T>(apiCall: () => Observable<T>): Observable<T> {
    if (!this.isSsoTokenValid()) {
      // If SSO token is not valid, use AuthService's login to fetch new access_token and expiration time
      localStorage.clear();
      this.getAuthService().login();
      return throwError(() => new Error('SSO token is not valid'));
    }
    return apiCall();
  }

  public getUserAccessBySSO(sso: string): Observable<any> {
    const apiCall = () => this.http.get<any>(`${this.apiURL}/user-access/${sso}`, {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${localStorage.getItem('backend_api_token')}`
      }),
      observe: 'body',
      responseType: 'json',
    })
    .pipe(retry(3), catchError(this.handleError));
    console.log('user access data')
    return this.handleApiCall(apiCall);
  }

  // Exchange authorization code for tokens
  public fetchAuthToken(code: string, local_trigger: boolean): Observable<any> {
    const apiCall = () => this.http.post<any>(`${this.apiURL}/auth/sso/`, { code, local_trigger }, {
      headers: new HttpHeaders(),
      observe: 'body',
      responseType: 'json',
    })
    .pipe(retry(3), catchError(this.handleError));
    return apiCall();
  }

  // Validate token with backend API and then send user info back
  public validateAuthToken(access_token: string): Observable<any> {
    //const apiCall = () => this.http.post<any>(`${this.apiURL}/auth/sso/validate`, { access_token }, {
    const apiCall = () => this.http.post<any>(`${this.apiURL}/auth/sso/`, { access_token }, {
      headers: new HttpHeaders(),
      observe: 'body',
      responseType: 'json',
    })
    .pipe(retry(3), catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        return throwError(() => new Error('Unauthorized'));
      }
      return this.handleError(error);
    }));
    return apiCall();
  }
}